import { useFormikContext } from "formik";
import { useState } from "react";
import { Stack } from "@/core/components/ui/stack/stack";
import { Typography } from "@/core/components/ui/typography";
import { IBusiness } from "@/business/business";
import { useBusiness } from "@/core/business";
import { downloadQRCode } from "@/core/utils/download-qr";
import { formatPhoneNumber } from "@/core/utils/phone";
import BusinessInfoPair from "./business-info-pair";

const BusinessSummary = ({ business }: { business: IBusiness }) => {
  const { isSpiffOnly } = useBusiness();
  const [isHovered, setIsHovered] = useState(false);
  const { values } = useFormikContext<Partial<IBusiness>>();

  const handleQRCodeDownload = () => {
    if (business?.qr_code_url) {
      downloadQRCode(business.qr_code_url);
    }
  };

  return (
    <Stack gap="lg" direction="row" fullWidth className="relative">
      <Stack gap="lg" fullWidth>
        <BusinessInfoPair label="Business name" value={values?.name} />
        <Stack align="start" direction="row" fullWidth gap="lg">
          {!isSpiffOnly && (
            <BusinessInfoPair
              label="Phone (for referrals)"
              value={
                formatPhoneNumber(values?.phone_number || "", {
                  withCountryCode: true,
                }) || ""
              }
            />
          )}
          <BusinessInfoPair
            // isEditMode={isEditMode} TODO: uncomment when ready
            label="Owner"
            value={" - "}
          />
          <BusinessInfoPair
            // isEditMode={isEditMode} TODO: uncomment when ready
            label="Address"
            value={" - "}
          />
        </Stack>
      </Stack>
      {business?.qr_code_url && (
        <div
          className="absolute right-0 top-0 cursor-pointer"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          onClick={handleQRCodeDownload}
        >
          <img
            src={business?.qr_code_url}
            alt="QR Code"
            className={`w-[160px] ${isHovered ? "blur-sm" : ""}`}
          />
          {isHovered && (
            <div className="absolute inset-0 flex items-center justify-center">
              <Typography variant="captionW1SemiBold">
                Download QR Code
              </Typography>
            </div>
          )}
        </div>
      )}
    </Stack>
  );
};

export default BusinessSummary;
